import { render } from "./DashboardPage.vue?vue&type=template&id=4bde849b&scoped=true&ts=true"
import script from "./DashboardPage.vue?vue&type=script&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&lang=ts"

import "./DashboardPage.vue?vue&type=style&index=0&id=4bde849b&scoped=true&lang=css"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bde849b"]])

export default __exports__